"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _SelectList = _interopRequireDefault(require("react-widgets/lib/SelectList"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _info = _interopRequireDefault(require("cccisd-icons/info2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _Disabled = _interopRequireDefault(require("../../pages/Code/Disabled"));
var _admin = require("../../selectors/admin");
var _metricTypes = _interopRequireDefault(require("../../pages/Code/metricTypes"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var MetricTypeDropdown = function MetricTypeDropdown(_ref) {
  var metricTypeDropdownVisible = _ref.metricTypeDropdownVisible,
    setMetricTypeDropdownVisible = _ref.setMetricTypeDropdownVisible,
    metricFilter = _ref.metricFilter,
    setMetricFilter = _ref.setMetricFilter,
    isUpdated = _ref.isUpdated;
  var restrictionsLevel = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getRestrictionsLevel)(state.assignment.admin);
  });
  var getMetricTypeTooltips = function getMetricTypeTooltips() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'table'
      }
    }, _metricTypes["default"].map(function (type, index) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'table-row'
        },
        key: index
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'table-cell',
          padding: '0.25em',
          paddingRight: '1.0em',
          fontWeight: 'bold',
          textAlign: 'right'
        }
      }, type.label), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'table-cell'
        }
      }, type.tooltip));
    }));
  };
  var switchMetricTypeMulti = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            setMetricFilter(value.map(function (item) {
              return (0, _get2["default"])(item, 'metricTypeHandle', item);
            }));
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function switchMetricTypeMulti(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var getMetricTypeButtonLabel = function getMetricTypeButtonLabel() {
    if (metricFilter.length === 1) {
      var s = _metricTypes["default"].find(function (item) {
        return item.value === metricFilter[0];
      });
      return s ? s.label : '';
    }
    return "".concat(metricFilter.length || 'All', " selected");
  };
  var metricTypeDropdownData = _metricTypes["default"].filter(function (type) {
    return type.value !== 'correct' || restrictionsLevel === 'unlimited';
  }).map(function (type) {
    return {
      metricTypeHandle: type.value,
      metricTypeLabel: type.label
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
    clickedOutside: function clickedOutside() {
      return setMetricTypeDropdownVisible(false);
    }
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "form-label",
    htmlFor: "cccisd-assignment-metric-type-dropdown"
  }, "Metric Type", ' ', /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: getMetricTypeTooltips(),
    maxWidth: "1000px"
  }, /*#__PURE__*/_react["default"].createElement(_info["default"], null)))), /*#__PURE__*/_react["default"].createElement(_Disabled["default"], {
    disabled: isUpdated
  }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    title: getMetricTypeButtonLabel(),
    className: "btn btn-secondary",
    isDisabled: isUpdated,
    onClick: function onClick() {
      return setMetricTypeDropdownVisible(!metricTypeDropdownVisible);
    },
    style: {
      display: 'block',
      maxWidth: '400px',
      whiteSpace: 'normal'
    }
  })), metricTypeDropdownVisible && /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      position: 'absolute'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    className: "btn btn-xs btn-secondary",
    isDisabled: metricTypeDropdownData.length === metricFilter.length,
    onClick: function onClick() {
      setMetricTypeDropdownVisible(false);
      switchMetricTypeMulti(metricTypeDropdownData);
    },
    title: "Select All"
  }), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
    className: "btn btn-xs btn-secondary",
    isDisabled: metricFilter.length === 0,
    onClick: function onClick() {
      setMetricTypeDropdownVisible(false);
      switchMetricTypeMulti([]);
    },
    title: "Deselect All"
  })), /*#__PURE__*/_react["default"].createElement(_SelectList["default"], {
    multiple: true,
    data: metricTypeDropdownData,
    textField: "metricTypeLabel",
    valueField: "metricTypeHandle",
    onChange: switchMetricTypeMulti,
    value: metricFilter,
    style: {
      display: metricTypeDropdownVisible ? 'block' : 'none',
      height: 'auto',
      marginTop: '2.5rem',
      position: 'absolute',
      zIndex: 11
    }
  }));
};
var _default = exports["default"] = MetricTypeDropdown;